import { useEffect, useState } from "react";

import { usePagination } from "@mui/lab";
import { Button, Stack } from "@mui/material";

import { ReactComponent as Arrow } from "../../../Assets/Images/Icon/ArrowICON.svg";
import "./style.css";

export const PaginationGrid = ({
  pagerData,
  onPageChange,
  resetCurrentPage,
}) => {
  const [count, setCount] = useState(pagerData?.totalPages);
  // Update count when pagerData changes
  useEffect(() => {
    setCount(pagerData?.totalPages);
  }, [pagerData]);

  const [currentPage, setCurrentPage] = useState(
    pagerData.currentPage || resetCurrentPage,
  );
  const { items } = usePagination({
    count: count,
    page: currentPage,
    siblingCount: 0,
  });

  // Reset current page when page size changes
  useEffect(() => {
    resetCurrentPage && setCurrentPage(1);
  }, [resetCurrentPage]);

  const paginationIndexHandler = (option) => {
    if (option === "next") {
      if (currentPage < pagerData.totalPages) {
        let currentPageAfter = currentPage + 1;
        setCurrentPage(currentPageAfter);
      }
    } else if (option === "previous") {
      if (currentPage > 1) {
        let currentPageAfter = currentPage - 1;
        setCurrentPage(currentPageAfter);
      }
    } else if (option === "start-ellipsis") {
      let currentPageAfter = items[3].page - 1;
      setCurrentPage(currentPageAfter);
      onPageChange(currentPageAfter);
    } else if (option === "end-ellipsis") {
      let currentPageAfter = items[3].page + 1;
      setCurrentPage(currentPageAfter);
      onPageChange(currentPageAfter);
    } else {
      setCurrentPage(option);
    }
  };

  return (
    <>
      <Stack direction={"row"} spacing={"16px"} height={"44px"}>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;
          if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = (
              <Button
                disableTouchRipple
                disableFocusRipple
                key={index}
                variant="OuterLineBlue"
                style={{
                  maxWidth: "44px",
                  minWidth: "44px",
                  maxHeight: "44px",
                  minHeight: "44px",
                }}
                sx={{
                  maxWidth: "44px",
                  minWidth: "44px",
                  maxHeight: "44px",
                  minHeight: "44px",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  onPageChange(page);
                  paginationIndexHandler(type);
                }}
              >
                ..
              </Button>
            );
          } else if (type === "page") {
            children = (
              <Button
                disableTouchRipple
                disableFocusRipple
                key={index}
                variant={selected ? "primaryBlue" : "OuterLineBlue"}
                sx={{
                  maxWidth: "44px",
                  minWidth: "44px",
                  maxHeight: "44px",
                  minHeight: "44px",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  onPageChange(page);
                  paginationIndexHandler(page);
                }}
              >
                {page}
              </Button>
            );
          } else {
            let arrowAccess = {
              hasNavigateData:
                pagerData?.currentPage !== undefined &&
                pagerData?.totalPages !== undefined,
              previous: undefined,
              next: undefined,
            };

            if (arrowAccess.hasNavigateData) {
              arrowAccess = {
                ...arrowAccess,
                next:
                  pagerData?.currentPage === pagerData?.totalPages
                    ? true
                    : false,
                previous: pagerData?.currentPage > 1 ? false : true,
              };
            }
            children = (
              <Button
                disableTouchRipple
                disableFocusRipple
                key={index}
                disabled={
                  arrowAccess.hasNavigateData && type == "previous"
                    ? arrowAccess?.previous
                    : arrowAccess?.next
                }
                variant="OuterLineBlue"
                sx={{
                  maxWidth: "44px",
                  minWidth: "44px",
                  maxHeight: "44px",
                  minHeight: "44px",
                  borderRadius: "8px",
                  border: "1.5px solid var(--SystemBlue-Light-6, #0062CC)",
                }}
                onClick={() => {
                  onPageChange(page);
                  paginationIndexHandler(type);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Arrow
                    role="img"
                    type="img"
                    aria-label="Arrow Icon"
                    style={{ rotate: type == "previous" ? "0deg" : "180deg" }}
                  />
                </div>
              </Button>
            );
          }

          return children;
        })}
      </Stack>
    </>
  );
};
